<template>
  <!-- house-data-analyse -->
  <div class="flex flex-col house">
    <div class="house-title">
      <h2>房源数据分析</h2>
    </div>
    <div class="flex-item house-table">
      <el-tabs v-model="tabDefaultName" type="card">
        <el-tab-pane label="全部" name="all">
          <div class="flex house-table-head">
            <div class="flex">
              <el-date-picker
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                v-model="table.dateValue"
                value-format="timestamp"
                unlink-panels
              >
              </el-date-picker>
            </div>
            <div class="house-city-select">
              <span>城市：</span>
              <el-cascader
                :options="citySelect.dataList"
                :props="citySelect.options"
                v-model="citySelect.currentCity"
                filterable
                clearable
                label="name"
              ></el-cascader>
            </div>
            <div class="flex-item"></div>
            <el-button
              type="primary"
              :loading="table.isLoading"
              @click="search"
              >搜索</el-button
            >
            <el-button @click="exportExcel" :loading="table.exportLoading">导出</el-button>
          </div>
          <div class="flex-item house-table-content">
            <el-table
              :data="table.dataList"
              border
              style="width: 100%"
              v-loading="table.isLoading"
            >
              <el-table-column
                v-for="item in table.fieldList"
                :key="item.label"
                :prop="item.prop"
                :label="item.label"
                align="center"
              />
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="pagination-wrapper">
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="table.pageSize"
        :total="table.total"
        :current-page="table.pageIndex"
        @size-change="pageSizeChange"
        @current-change="paginationChange"
        layout="total, sizes, prev, pager, next, jumper"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import config from '@/config/index.js'
import { excludeNullProperty, downloadExcel } from '@/common/util.js'

export default {
  data() {
    return {
      tabDefaultName: 'all',
      citySelect: {
        dataList: [],
        currentCity: '',
        options: {
          label: 'name',
          emitPath: false, // 决定 change 事件返回的是当前值还是数组
        },
      },
      table: {
        fieldList: [
          {
            prop: 'createTime',
            label: '时间',
          },
          {
            prop: 'cityName',
            label: '城市',
          },
          {
            prop: 'second_count',
            label: '二手房-出售',
          },
          {
            prop: 'second_countc',
            label: '二手房-出租',
          },
          {
            prop: 'shops_count',
            label: '商铺-出售',
          },
          {
            prop: 'shops_countc',
            label: '商铺-出租',
          },
          {
            prop: 'building_count',
            label: '写字楼-出售',
          },
          {
            prop: 'building_countc',
            label: '写字楼-出租',
          },
          {
            prop: 'totalCount',
            label: '总房源数',
          },
        ],
        dateValue: null,
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        total: 0,
        isLoading: false,
        exportLoading: false,
      },
    }
  },
  created() {
    // 获取城市列表
    this.fetchCity()
    // 获取表格数据(需要在 initStartTime 之后调用)
    this.fetchDataList()
  },
  methods: {
    // 城市选择器数据
    async fetchCity() {
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
      const res = await Axios.get(
        `${config.API}/web/search_properties/city_name`,
        {
          headers: {
            Authorization: userInfo.jti,
          },
        }
      )
      const data = res.data
      if (data.status !== 200) return
      this.citySelect.dataList.push(
        ...data.data.map((item) => {
          // 让Vue不对其进行响应式初始化
          return Object.freeze({ ...item, value: item.name })
        })
      )
    },
    // 表格部分
    async fetchDataList() {
      const { currentCity: cityName } = this.citySelect
      const { dateValue, pageIndex, pageSize } = this.table
      const params = excludeNullProperty({
        pageNo: pageIndex,
        pageSize,
        cityName,
        startTime: dateValue ? dateValue[0] : null,
        endTime: dateValue ? dateValue[1] : null,
        order: this.table.order
      })
      this.table.isLoading = true
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
      const res = await Axios.get(
        // `${config.API}/web/search_properties/HosePageType`,
        `/ys/search_properties/HosePageType`,
        {
          params: params,
          headers: {
            Authorization: userInfo.jti,
          },
        }
      )
      const data = res.data
      this.formatTableList(data)
      this.table.isLoading = false
    },
    formatTableList({ data }) {
      this.table.total = data.total
      this.table.dataList.splice(0)
      this.table.dataList.push(...data.list)
    },
    // 分页
    pageSizeChange(pageSize) {
      this.table.pageSize = pageSize
      this.fetchDataList()
    },
    paginationChange(pageIndex) {
      this.table.pageIndex = pageIndex
      this.fetchDataList()
    },
    // 搜索
    search() {
      this.table.pageIndex = 1;
      this.fetchDataList()
    },
    // 导出 excel
    async exportExcel() {
      const { currentCity: cityName } = this.citySelect
      const { dateValue, pageIndex, pageSize } = this.table
      const params = excludeNullProperty({
        cityName,
        pageNo: pageIndex,
        pageSize: pageSize,
        startTime: dateValue ? dateValue[0] : null,
        endTime: dateValue ? dateValue[1] : null,
      })

      this.table.exportLoading = true;
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
      const res = await Axios.post(`${config.API}/web/exportListxl`, params, {
        headers: {
          Authorization: userInfo.jti,
        },
        responseType: 'blob',
      })
      this.table.exportLoading = false;
      downloadExcel(res.data)
    },
  },
}
</script>

<style lang="scss" scoped>
.house {
  .house-title {
    padding-left: 12px;
    line-height: 1;
    border-left: 6px solid #409eff;
    font-size: 14px;
  }
  .house-table {
    margin-top: 24px;
    .house-table-head {
      padding: 24px 16px;
      border: 1px solid #ebeef5;
      border-bottom: 0;
    }
    .house-city-select {
      margin-left: 16px;
    }
  }
  .pagination-wrapper {
    padding: 24px 0;
  }
}
</style>